module.exports = __webpack_public_path__ + "img/18.5bd74c1d.png";